import { EnvironmentInterface } from '../interfaces/environment.interface';

export const environment: EnvironmentInterface = {
  production: true,
  apiDomain: 'eurouat.bi4dev.com',
  universityApiDomain: 'app.uat.educa.university',
  apiProtocol: 'https',
  apiPath: 'api',
  lhcURL: 'lhcdev.bi4dev.com',
  verticalURL: 'eurouat.bi4dev.com',
  universityURL: 'uat.app.educa.university',
  captchaKey: '6Les7D0dAAAAAIffPAHBCNTHFnKnG6pcm1YqkuNR',
  regionsAvailables: ['EU']
};
